export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14216.03ea793a.jpg";